import { Modal, Tabs } from "antd";
import React, { Component } from "react";

import DosageDirection from "./TabsComponents/DosageDirection";
import DoseFrequency from "./TabsComponents/DoseFrequency";
import DoseInformation from "./TabsComponents/DoseInformation";
import MedicineTenure from "./TabsComponents/MedicineTenure";

const { TabPane } = Tabs;

class MedInfoModal extends Component {
  state = {
    activeKey: "1",
  };

  changeActiveKey = (value) => {
    this.setState({ activeKey: value });
  };

  render() {
    const {
      visible,
      onCancel,
      data,
      selectedMed,
      handleDoseInfo,
      handleDoseDirection,
      handleDoseFrequency,
      handleMedicineTenure,
      handleSubmitFromDosageDirection,
    } = this.props;

    const { activeKey } = this.state;

    return (
      <Modal
        visible={visible}
        style={{ top: 20 }}
        width="70%"
        onCancel={onCancel}
        maskStyle={{ background: "rgba(51, 51, 51, 0.6)" }}
        footer={null}
      >
        <Tabs activeKey={activeKey} tabBarStyle={{ textAlign: "center" }}>
          <TabPane tab="Dose Information" key="1">
            <DoseInformation
              valueForm={selectedMed.split("#")[4]}
              data={data}
              changeActiveKey={this.changeActiveKey}
              selectedMed={selectedMed}
              handleDoseInfo={handleDoseInfo}
            />
          </TabPane>

          <TabPane tab="Dosage Direction" key="2">
            <DosageDirection
              data={data}
              changeActiveKey={this.changeActiveKey}
              selectedMed={selectedMed}
              handleDoseDirection={handleDoseDirection}
              handleSubmitFromDosageDirection={handleSubmitFromDosageDirection}
              onCancel={onCancel}
            />
          </TabPane>

          <TabPane tab="Dose Frequency" key="3">
            <DoseFrequency
              data={data}
              changeActiveKey={this.changeActiveKey}
              selectedMed={selectedMed}
              handleDoseFrequency={handleDoseFrequency}
            />
          </TabPane>

          <TabPane tab="Medicine Tenure" key="4">
            <MedicineTenure
              data={data}
              changeActiveKey={this.changeActiveKey}
              selectedMed={selectedMed}
              handleMedicineTenure={handleMedicineTenure}
              onCancel={onCancel}
            />
          </TabPane>
        </Tabs>
      </Modal>
    );
  }
}

export default MedInfoModal;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/MedInfoModal.js